import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_LAST_MINUTE_BACKUP_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import { DSIcon } from '../../../base';

import styles from './LastMinuteBackupModal.module.scss';

const LastMinuteBackupModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_LAST_MINUTE_BACKUP_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="normal"
      className={styles['last-minute-backup-modal']}
    >
      <ModalHeader
        className={styles['last-minute-backup-modal__header']}
        onRequestClose={handleModalClose}
        label={
          <>
            <DSIcon name="support" size="ml" />
            <br />
            {trans('last.minute.backup.modal.title')}
          </>
        }
      />
      <ModalBody className={styles['last-minute-backup-modal__body']}>
        <p>{trans('last.minute.backup.modal.description')}</p>

        <div>
          <h5 className={styles['last-minute-backup-modal__conditions-title']}>
            {trans('last.minute.backup.modal.conditions1')}
          </h5>
          <ul className={styles['last-minute-backup-modal__conditions-list']}>
            <li>{trans('last.minute.backup.modal.conditions1.item1')}</li>
            <li>{trans('last.minute.backup.modal.conditions1.item2')}</li>
            <li>{trans('last.minute.backup.modal.conditions1.item3')}</li>
          </ul>
        </div>

        <div>
          <h5 className={styles['last-minute-backup-modal__conditions-title']}>
            {trans('last.minute.backup.modal.conditions2')}
          </h5>
          <p>{trans('last.minute.backup.modal.conditions2.item1')}</p>
        </div>
      </ModalBody>
    </Modal>
  ) : null;
};

export default LastMinuteBackupModal;
